import { i18n } from 'vue-infra';
import { METRIC_NAMES } from '@config/Consts';

/**
 * sending the metric reason and the with the relevant metric
 * @param options
 * @returns {{general: *, metricName: *, personal: string}}
 */
function makePendingRateReason(options) {
  const { condition, value, agentName } = options;
  const metricName = i18n.t('amd:metric_pending');
  const reason = i18n.t(`amd:metric_alert_${condition}`, { metricName, value },
  );
  return {
    general: reason,
    personal: `${agentName} ${reason}`,
    metricName,
  };
}

export const i18nHandlers = {
  [METRIC_NAMES.AGENT_VIEW_PENDING_RATE]: makePendingRateReason,
};
